import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changePassword } from '../actions';
import ChangePasswordForm from './ChangePasswordForm';
import { withNamespaces } from 'react-i18next';

class ChangePassword extends Component {

	render() {
		return <ChangePasswordForm onSubmit={this.props.changePassword} />;
	}
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps, {
	changePassword
})(withNamespaces()(ChangePassword));